"use strict";

var PDFJS = require('pdfjs-dist/webpack.js');

function PDFJSWrapper(PDFJS, canvasElt, annotationLayerElt, emitEvent) {

  var pdfDoc = null;
  var pdfPage = null;
  var pdfRender = null;

  function clearCanvas() {

    canvasElt.getContext('2d').clearRect(0, 0, canvasElt.width, canvasElt.height);
  }

  function clearAnnotations() {

    while (annotationLayerElt.firstChild)
      annotationLayerElt.removeChild(annotationLayerElt.firstChild);
  }

  this.destroy = function () {

    if (pdfDoc === null)
      return;
    pdfDoc.destroy();
    pdfDoc = null;
  }

  this.getResolutionScale = function () {

    return canvasElt.offsetWidth / canvasElt.width;
  }

  this.printPage = function (dpi, pageNumberOnly) {

    if (pdfPage === null)
      return;

    // 1in == 72pt
    // 1in == 96px
    var PRINT_RESOLUTION = dpi === undefined ? 150 : dpi;
    var PRINT_UNITS = PRINT_RESOLUTION / 72.0;
    var CSS_UNITS = 96.0 / 72.0;

    var iframeElt = document.createElement('iframe');

    function removeIframe() {

      iframeElt.parentNode.removeChild(iframeElt);
    }

    new Promise(function (resolve, reject) {

      iframeElt.frameBorder = '0';
      iframeElt.scrolling = 'no';
      iframeElt.width = '0px;'
      iframeElt.height = '0px;'
      iframeElt.style.cssText = 'position: absolute; top: 0; left: 0';

      iframeElt.onload = function () {

        resolve(this.contentWindow);
      }

      window.document.body.appendChild(iframeElt);
    })
      .then(function (win) {

        win.document.title = '';

        return pdfDoc.getPage(1)
          .then(function (page) {

            var viewport = page.getViewport(1);
            win.document.head.appendChild(win.document.createElement('style')).textContent =
              '@supports ((size:A4) and (size:1pt 1pt)) {' +
              '@page { margin: 1pt; size: ' + ((viewport.width * PRINT_UNITS) / CSS_UNITS) + 'pt ' + ((viewport.height * PRINT_UNITS) / CSS_UNITS) + 'pt; }' +
              '}' +

              '@media print {' +
              'body { margin: 0 }' +
              'canvas { page-break-before: avoid; page-break-after: always; page-break-inside: avoid }' +
              '}' +

              '@media screen {' +
              'body { margin: 0 }' +
              '}' +

              ''
            return win;
          })
      })
      .then(function (win) {

        var allPages = [];

        for (var pageNumber = 1; pageNumber <= pdfDoc.numPages; ++pageNumber) {

          if (pageNumberOnly !== undefined && pageNumberOnly.indexOf(pageNumber) === -1)
            continue;

          allPages.push(
            pdfDoc.getPage(pageNumber)
              .then(function (page) {

                var viewport = page.getViewport(1);

                var printCanvasElt = win.document.body.appendChild(win.document.createElement('canvas'));
                printCanvasElt.width = (viewport.width * PRINT_UNITS);
                printCanvasElt.height = (viewport.height * PRINT_UNITS);

                return page.render({
                  canvasContext: printCanvasElt.getContext('2d'),
                  transform: [ // Additional transform, applied just before viewport transform.
                    PRINT_UNITS, 0, 0,
                    PRINT_UNITS, 0, 0
                  ],
                  viewport: viewport,
                  intent: 'print'
                }).promise;
              })
          );
        }

        Promise.all(allPages)
          .then(function () {

            win.focus(); // Required for IE
            win.print();
            removeIframe();
          })
          .catch(function (err) {

            removeIframe();
            emitEvent('error', err);
          })
      })
  }

  this.renderPage = function (rotate) {

    if (pdfRender !== null)
      return pdfRender.cancel();

    if (pdfPage === null)
      return;

    if (rotate === undefined)
      rotate = 0;

    var viewport = pdfPage.getViewport(canvasElt.offsetWidth / pdfPage.getViewport(1).width, rotate);

    emitEvent('pageSize', viewport.width, viewport.height);

    canvasElt.width = viewport.width;
    canvasElt.height = viewport.height;

    pdfRender = pdfPage.render({
      canvasContext: canvasElt.getContext('2d'),
      viewport: viewport
    });

    annotationLayerElt.style.visibility = 'hidden';
    clearAnnotations();

    pdfPage.getAnnotations()
      .then(function (annotations) {

        PDFJS.AnnotationLayer.render({
          viewport: viewport.clone({ dontFlip: true }),
          div: annotationLayerElt,
          annotations: annotations,
          page: pdfPage,
          //linkService: new LinkServiceMock(),
          renderInteractiveForms: false,
        });
      });

    pdfRender
      .then(function () {

        annotationLayerElt.style.visibility = '';
        pdfRender = null;
      })
      .catch(function (err) {

        pdfRender = null;
        if (err === 'cancelled')
          return this.renderPage(rotate);
        emitEvent('error', err);
      }.bind(this))
  }

  this.loadPage = function (pageNumber, rotate) {

    pdfPage = null;

    if (pdfDoc === null)
      return;

    pdfDoc.getPage(pageNumber)
      .then(function (page) {

        pdfPage = page;
        this.renderPage(rotate);
        emitEvent('pageLoaded', page.pageNumber);
      }.bind(this))
      .catch(function (err) {

        clearCanvas();
        clearAnnotations();
        emitEvent('error', err);
      });
  }

  this.loadDocument = function (src) {

    pdfDoc = null;
    pdfPage = null;

    emitEvent('numPages', undefined);

    if (!src) {

      canvasElt.removeAttribute('width');
      canvasElt.removeAttribute('height');
      clearAnnotations();
      return;
    }

    var loadingTask = PDFJS.getDocument(src);

    loadingTask.onPassword = function (updatePassword, reason) {

      var reasonStr;
      switch (reason) {
        case PDFJS.PasswordResponses.NEED_PASSWORD:
          reasonStr = 'NEED_PASSWORD';
          break;
        case PDFJS.PasswordResponses.INCORRECT_PASSWORD:
          reasonStr = 'INCORRECT_PASSWORD';
          break;
      }
      emitEvent('password', updatePassword, reasonStr);
    };

    loadingTask.onProgress = function (status) {

      var ratio = status.loaded / status.total;
      emitEvent('progress', Math.min(ratio, 1));
    }

    loadingTask
      .then(function (pdf) {

        pdfDoc = pdf;
        emitEvent('numPages', pdf.numPages);
        emitEvent('loaded');
      })
      .catch(function (err) {

        clearCanvas();
        clearAnnotations();
        emitEvent('error', err);
      })
      .then(function () {

        loadingTask._worker = null;
      })

  }

  PDFJS.CustomStyle.setProp('transform-origin', annotationLayerElt, '0 0');
}

export {
  PDFJSWrapper
}



// WEBPACK FOOTER //
// ./~/iexplore/components/pdf/static/pdf.js